import React, { Component } from 'react'
import { Tooltip, Box } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/pro-duotone-svg-icons/faTrashAlt'
import { LoadingDefault } from '@/shared/ui/loading'
import AppDialog from '@/shared/ui/app-dialog/AppDialog'
import { StyledButton } from '@/shared/ui/buttons'

class MultiContentDossierDelete extends Component {
    constructor(props) {
        super(props)

        this.state = {
            DeleteDefDossierForm: false,
            submitting: false,
        }

        this.deleteSelectedItems = this.deleteSelectedItems.bind(this)
        this.handleClose = this.handleClose.bind(this)
    }

    handleClose() {
        this.setState({ DeleteDefDossierForm: false })
        if (this.props.onCancel) {
            this.props.onCancel()
        }
    }

    handleErrors(errorData) {
        //TODO
    }

    async deleteSelectedItems() {
        if (!this.props.items) {
            return
        }

        this.setState({ submitting: true })
        let selectedItems = this.props.items
        let x

        let allSelectedItems = selectedItems.length
        let counter = 0

        const forLoop = async (_) => {
            for (x of selectedItems) {
                this.setState({ delete: true })

                try {
                    const response = await this.props.kedo
                        .api()
                        .delete(
                            this.props.kedo.api().getContentDossierEndpoint() +
                                '/' +
                                x
                        )
                    counter = counter + 1
                    if (counter === allSelectedItems) {
                        this.setState({
                            submitting: false,
                            DeleteDefDossierForm: false,
                        })
                        this.props.onClose()
                    }
                } catch (e) {
                    this.handleErrors(e.response)
                    this.setState({
                        delete: false,
                        errors: true,
                    })
                }
            }
        }
        await forLoop()
    }

    formDelete() {
        return (
            <AppDialog
                aria-labelledby="contained-modal-title-vcenter"
                open
                fullWidth
                title={this.props.kedo.t('Confirmation')}
                onClose={this.handleClose}
                headerClose={this.handleClose}
                contentProps={{ dividers: true }}
                actions={
                    <>
                        <StyledButton
                            onClick={this.deleteSelectedItems}
                            color="error"
                        >
                            {this.state.submitting ? (
                                <LoadingDefault size={'sm'} as={'span'} />
                            ) : (
                                <FontAwesomeIcon icon={faTrashAlt} />
                            )}
                            &nbsp; {this.props.kedo.t('Delete')}
                        </StyledButton>{' '}
                        &nbsp;
                        <StyledButton
                            onClick={this.handleClose}
                            color="secondary"
                        >
                            {this.props.kedo.t('Cancel')}
                        </StyledButton>
                    </>
                }
            >
                <Box component="form">
                    {(() => {
                        const itemLabel =
                            (typeof this.props.itemName === 'string' &&
                                this.props.itemName.trim()) ||
                            null

                        return this.props.items.length > 1
                            ? this.props.kedo.t('confirm_delete_text_plural', {
                                  item:
                                      itemLabel ||
                                      this.props.kedo.t('Dossiers'),
                                  items:
                                      itemLabel ||
                                      this.props.kedo.t('Dossiers'),
                              })
                            : this.props.kedo.t(
                                  'confirm_delete_text_singular',
                                  {
                                      item:
                                          itemLabel ||
                                          this.props.kedo.t('Dossier'),
                                  }
                              )
                    })()}
                </Box>
            </AppDialog>
        )
    }

    displayButton(onClick, button, tooltip = null) {
        if (!tooltip)
            return (
                <StyledButton
                    size={this.props.size}
                    variant={'outlined'}
                    color="error"
                    onClick={onClick}
                >
                    {button}
                </StyledButton>
            )

        return (
            <Tooltip title={tooltip} placement="top">
                <StyledButton
                    variant={'outlined'}
                    color="error"
                    onClick={onClick}
                >
                    {button}
                </StyledButton>
            </Tooltip>
        )
    }

    render() {
        if (this.state.DeleteDefDossierForm || this.props.showModal) {
            return this.formDelete()
        }

        const mode = this.props.mode

        return (
            <>
                {this.displayButton(
                    () =>
                        this.setState({
                            DeleteDefDossierForm: true,
                            loading: true,
                        }),
                    <>
                        <FontAwesomeIcon icon={faTrashAlt} />{' '}
                        {mode &&
                        (mode === 'embeddedList' || mode === 'block') ? null : (
                            <>&nbsp; {this.props.kedo.t('Delete')}</>
                        )}
                    </>,
                    mode && (mode === 'embeddedList' || mode === 'block')
                        ? this.props.kedo.t('Delete')
                        : null
                )}
            </>
        )
    }
}

export default MultiContentDossierDelete
